/* Angular Module */
import {Injectable} from '@angular/core';
import {JobType} from '@models/JobView';

@Injectable()
export class CommonService {

  padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }

  isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

  isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }

  toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }

  getStatusIcon(status: 'NotApplicable' | 'Open' | 'Complete' | 'Cancelled' | 'AwaitingClosure' | 'InProgress'): string {
    switch (status) {
      case 'Complete':
        return 'tick';
      case 'Open':
        return 'in preperation';
      case 'AwaitingClosure':
        return 'warning';
      default:
        return 'not published';
    }
  }

  getJobIcon(jobType: JobType) {
    switch (jobType) {
      case JobType.NotApplicable:
        return 'warning';
      case JobType.Install:
        return 'messages';
      case JobType.Service:
        return 'activity';
    }
  }
}

